export const infracaoFilterConfig = [
  {
    id: 'Descricao',
    type: 'text',
    label: 'Descricao',
    placeholder: 'Digite a descricao da infracao'
  }
];
